<template>
  <v-dialog v-model="opened" max-width="700" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? "Tambah" : "Ubah" }} Hold Package
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  class="member-field"
                  label="Member"
                  dense
                  outlined
                  v-model="data.member_id"
                  :items="listMembers"
                  item-text="name"
                  item-value="id"
                  :rules="rules.member_id"
                  :readonly="!!id"
                  :clearable="!id"
                  :menu-props="{ disabled: !!id }"
                  :append-outer-icon="id ? 'mdi-lock' : undefined"
                  :hint="id ? 'Terkunci saat ubah data' : ''"
                  :persistent-hint="!!id"
                />
              </v-col>

              <v-col cols="12" md="6">
                <date-picker
                  class="mb-6"
                  placeholder="Tanggal Mulai Hold"
                  valueType="format"
                  :format="'YYYY-MM-DD'"
                  v-model="data.start_hold_date"
                  :disabled="isLockedVerified"
                />
              </v-col>

              <v-col cols="12" md="6">
                <date-picker
                  class="mb-6"
                  placeholder="Tanggal Kembali"
                  valueType="format"
                  :format="'YYYY-MM-DD'"
                  v-model="data.return_date"
                  :disabled="isLockedVerified"
                />
              </v-col>

              <v-col cols="12">
                <div class="ml-3">Dokumen Pendukung</div>
                <FileUpload
                  v-model="data.document_file_id"
                  :labelIdle="'Unggah Dokumen'"
                  category="file"
                  :key="data.document_file_id"
                  :disabled="isLockedVerified"
                  :allow_remove="!isLockedVerified"
                ></FileUpload>
              </v-col>

              <v-col cols="12" v-if="canVerification">
                <v-autocomplete
                  label="Status"
                  dense
                  outlined
                  v-model="data.status"
                  :items="listStatuses"
                  item-text="name"
                  item-value="id"
                  clearable
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-end mr-4">
          <v-btn depressed class="ma-1" :disabled="loading" @click="close()">
            <v-icon small left>mdi-close</v-icon>
            Tutup
          </v-btn>
          <v-btn
            v-if="canSubmit"
            type="submit"
            color="success"
            depressed
            class="ma-1"
            :loading="loading"
            :disabled="loading"
            @click.prevent="save()"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import FileUpload from "@/view/component/FileUpload.vue";

export default {
  async mounted() {
    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;
  },
  data() {
    return {
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      originalData: null,
      listMembers: [],
      listStatuses: [
        { id: "unverified", name: "Unverified" },
        { id: "verified", name: "Verified" }
      ],
      data: {
        member_id: null,
        start_hold_date: null,
        return_date: null,
        document_file_id: null,
        status: "unverified"
      },
      rules: {
        member_id: [v => !!v || "Member harus dipilih"],
        start_hold_date: [v => !!v || "Tanggal mulai hold harus diisi"]
      }
    };
  },
  props: {
    module: {
      type: String
    },
    success: {
      type: Function,
      default: function() {}
    }
  },
  methods: {
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.form.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get("hold-package?id=" + id)
        .then(({ data }) => {
          this.data = {
            member_id: data.member_id,
            start_hold_date: data.start_hold_date,
            return_date: data.return_date,
            document_file_id: data.document_file_id,
            status: data.status || "unverified"
          };
          this.originalData = { ...this.data };
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        if (this.isLockedVerified && !this.canVerification) {
          this.$swal.fire({
            icon: "info",
            title: "Tidak Diizinkan",
            text: "Data yang sudah diverifikasi hanya dapat diubah statusnya oleh akun dengan hak verifikasi.",
            showConfirmButton: true
          });
          return;
        }

        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "hold-package";
        if (this.id) {
          url = url + "?id=" + this.id;
        }

        const payload = { ...this.data };
        if (this.isLockedVerified && this.originalData) {
          payload.member_id = this.originalData.member_id;
          payload.start_hold_date = this.originalData.start_hold_date;
          payload.return_date = this.originalData.return_date;
          payload.document_file_id = this.originalData.document_file_id;
        }

        ApiService[action](url, payload)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }
            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.$refs.form && this.$refs.form.reset();
      this.originalData = null;
      this.data = {
        member_id: null,
        start_hold_date: null,
        return_date: null,
        document_file_id: null,
        status: "unverified"
      };
      this.success();
    }
  },
  components: {
    FileUpload
  },
  computed: {
    isLockedVerified() {
      return !!this.id && this.originalData?.status === "verified";
    },
    canSubmit() {
      if (!this.id) return this.canEdit;
      if (this.isLockedVerified) return this.canVerification;
      return this.canEdit;
    },
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    },
    canVerification() {
      return (
        this.id &&
        this.$store.getters.hasPermission(this.module, "verification")
      );
    }
  }
};
</script>
